import { menuState } from 'js/main';

export default function (menuState) {
	const debug = menuState.debug || false;

	// Convert .main-menu__link anchors to buttons
	document.querySelectorAll('.main-menu__link').forEach(link => {
		if (link.tagName.toLowerCase() === 'a' && link.getAttribute('href') === '#') {
			const button = document.createElement('button');

			// Copy over key attributes and inner content
			button.className = link.className;
			button.innerHTML = link.innerHTML;
			button.setAttribute('type', 'button');
			button.setAttribute('aria-haspopup', link.getAttribute('aria-haspopup') || 'false');
			button.setAttribute('aria-expanded', link.getAttribute('aria-expanded') || 'false');

			link.parentNode.replaceChild(button, link);
		}
	});

	const submenuTriggers = document.querySelectorAll('.js-submenu-trigger');
	const subSubmenuTriggers = document.querySelectorAll('.js-sub-submenu-trigger');
	const closeButtons = document.querySelectorAll('.js-submenu-close-button');

	if (debug) console.group('Submenus + Sub-submenus');

	const closeAllMenus = () => {
		if (debug) console.log('••| closing ALL menus');
		submenuTriggers.forEach(trigger => closeMenuByTrigger(trigger));
		subSubmenuTriggers.forEach(trigger => closeMenuByTrigger(trigger));
		removeGlobalEventListeners();
	};

	const closeMenuByTrigger = (trigger) => {
		trigger.classList.remove('--is-active');
		trigger.setAttribute('aria-expanded', 'false');

		const menuID = trigger.id.replace('submenu-open-', 'submenu-').replace('sub-submenu-open-', 'sub-submenu-');
		const submenu = document.getElementById(menuID);

		if (submenu) {
			submenu.classList.remove('--is-opened');

			const parentItem = trigger.closest('.main-menu__list-item');
			if (parentItem) {
				parentItem.classList.remove('--is-opened');

				let menuLink = null;
				if (parentItem) {
					menuLink = parentItem.querySelector('.main-menu__link');
				}
				if (menuLink) {
					menuLink.setAttribute('aria-expanded', 'false');
				}
			}
		}
	};

	const addGlobalEventListeners = () => {
		document.addEventListener('keydown', handleKeydown);
		document.addEventListener('click', handleClick);
		document.addEventListener('focusin', handleFocusin);
	};

	const removeGlobalEventListeners = () => {
		document.removeEventListener('keydown', handleKeydown);
		document.removeEventListener('click', handleClick);
		document.removeEventListener('focusin', handleFocusin);
	};

	const handleKeydown = event => {
		if (event.key === 'Escape') {
			if (debug) console.log('•••| ESC key pressed, closing all menus');
			closeAllMenus();
		}
	};

	const handleClick = event => {
		const openMenus = document.querySelectorAll('.submenu.--is-opened, .sub-submenu.--is-opened');
		const isClickInsideAnyOpenMenu = Array.prototype.some.call(openMenus, function (menu) {
			return menu.contains(event.target);
		});
		if (!isClickInsideAnyOpenMenu) {
			if (debug) console.log('•••| Click outside menu, closing all menus');
			closeAllMenus();
		}
	};

	const handleFocusin = event => {
		const openMenus = document.querySelectorAll('.submenu.--is-opened, .sub-submenu.--is-opened');
		const isFocusInsideAnyOpenMenu = Array.prototype.some.call(openMenus, function (menu) {
			return menu.contains(event.target);
		});
		if (!isFocusInsideAnyOpenMenu) {
			if (debug) console.log('•••| Focus moved outside open menu, closing all menus');
			closeAllMenus();
		}
	};

	const handleToggle = (trigger, type = 'submenu') => {
		const parentItem = trigger.closest('.main-menu__list-item');
		let menuLink = null;
		if (parentItem) {
			menuLink = parentItem.querySelector('.main-menu__link');
		}

		const toggleMenu = event => {
			event.stopPropagation();
			if (debug) console.log(`•| ${type} toggle clicked`);

			const isActive = trigger.classList.toggle('--is-active');
			trigger.setAttribute('aria-expanded', isActive.toString());

			const menuID = trigger.id.replace(`${type}-open-`, `${type}-`);
			const submenu = document.getElementById(menuID);
			if (submenu) {
				if (debug) console.log(`••| Toggling ${type} class on ${menuID}`);
				submenu.classList.toggle('--is-opened');

				if (parentItem) {
					parentItem.classList.toggle('--is-opened', isActive);
					if (menuLink) {
						menuLink.setAttribute('aria-expanded', isActive.toString());
					}
				}
			}

			if (isActive) {
				addGlobalEventListeners();
			} else {
				const anyActive = document.querySelector('.js-submenu-trigger.--is-active, .js-sub-submenu-trigger.--is-active');
				if (!anyActive) {
					removeGlobalEventListeners();
				}
			}
		};

		trigger.addEventListener('click', toggleMenu);

		if (menuLink && menuLink !== trigger) {
			menuLink.addEventListener('click', toggleMenu);
		}
	};

	submenuTriggers.forEach(trigger => handleToggle(trigger, 'submenu'));
	subSubmenuTriggers.forEach(trigger => handleToggle(trigger, 'sub-submenu'));

	closeButtons.forEach(button => {
		button.addEventListener('click', event => {
			event.stopPropagation();
			if (debug) console.log('•| Submenu close button clicked');
			closeAllMenus();
		});
	});

	if (debug) console.groupEnd();
}
